/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The column a delivery list is ordered by. Ties break on newest first.
 * @export
 */
export const WebhookDeliverySortKey = {
    CreatedAt: 'createdAt',
    EventType: 'eventType',
    State: 'state',
    HttpStatus: 'httpStatus'
} as const;
export type WebhookDeliverySortKey = typeof WebhookDeliverySortKey[keyof typeof WebhookDeliverySortKey];


export function instanceOfWebhookDeliverySortKey(value: any): boolean {
    for (const key in WebhookDeliverySortKey) {
        if (Object.prototype.hasOwnProperty.call(WebhookDeliverySortKey, key)) {
            if (WebhookDeliverySortKey[key as keyof typeof WebhookDeliverySortKey] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WebhookDeliverySortKeyFromJSON(json: any): WebhookDeliverySortKey {
    return WebhookDeliverySortKeyFromJSONTyped(json, false);
}

export function WebhookDeliverySortKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebhookDeliverySortKey {
    return json as WebhookDeliverySortKey;
}

export function WebhookDeliverySortKeyToJSON(value?: WebhookDeliverySortKey | null): any {
    return value as any;
}

export function WebhookDeliverySortKeyToJSONTyped(value: any, ignoreDiscriminator: boolean): WebhookDeliverySortKey {
    return value as WebhookDeliverySortKey;
}

